module.exports = __webpack_public_path__ + "static/img/nangua.7642b370.png";